import { EmployeeLicenseUpgradeComponent } from '../businesses/components/employee-license-upgrade.component';
import { EmployeeLicenseUsageComponent } from '../businesses/components/employee-license-usage.component';
import { FeaturesBaseServices } from './../features/services/features-base.services';
import { EcplTabNavigationModule } from './../../shared/ecpl-tab-navigation/ecpl-tab-navigation.module';
import { FunctionListResolver } from './../contact/services/contact.resolver.service';
import {
  TimeTableEditResolver,
  EmployeeContactUserResolver
} from './../time-table/services/timetable.resolver.service';

import { BaseServices } from 'src/app/kuba/kuba.services';
import { PopoverModule } from 'primeng/popover';
import { MenuModule } from 'primeng/menu';
import { FirstOfKinListResolver } from './services/employeefirstofkin.resolver.service';
import { BusinessCreatorResolver } from './../businesses/services/business.resolver.service';
import {
  EmpLeaveListResolver,
  ApprovalPersonResolver,
  EmpLeaveByLeaveResolver,
  SicknessAbsenceCodeResolver,
  ResposibleExecutionResolver,
  BusinessHolidaysResolver
} from './services/employeeleave.resolver.service';
import { EmployeeFirstOfKinServices } from './services/employeefirstofkin.service';
import {
  ApprovalDocumentResolver,
  DocumentedTrainingResolver,
  EmployeePrivateDocResolver,
  MultiDocumentedTrainingResolver
} from './services/employeeprivatedoc.resolver.service';
import { EmployeePrivateDocumentServices } from './services/employeeprivatedocument.service';
import {
  EmployeeWorkExperienceResolver,
  CountryCodeResolver
} from './services/employeeWorkExperience.resolver.service';
import { EmployeeWorkExperienceServices } from './services/employeeworkexperience.service';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppSharedModule } from './../shared/appShared.module';
import { EmployeesComponent } from './employees.component';
import {
  EmployeeListResolver,
  EmployeeEditResolver,
  EmployeeSicknessListResolver,
  CourseEditResolver,
  CourseListResolver,
  BusinessCourseResolver,
  BusinessContractResolver,
  EmployeeTimeTableResolver,
  DepartmentDropDownResolver,
  PositionDropDownResolver,
  EmployeeDropDownResolver,
  EmployeeLeaveResolver,
  EmployeeActiveStatusResolver,
  EmployeeDocResolver,
  EmployeeSicknessByIdResolver,
  PortalEmployeeListResolver,
  PortalCourseListResolver,
  // PortalCourseResolver,
  BusinessAbsenceCodesBusinessResolver,
  UserDetailsResolver,
  EmployeeSubDepartmentResolver,
  EmployeeBusinessDataResolver,
  CourseListContractResolver,
  PortalContractListResolver
} from './services/employee.resolver.service';
import { EmployeeServices } from './services/employee.services';
import { EmployeeCourseServices } from './services/employeecourse.service';
import { EmployeeSicknessServices } from './services/employeesickness.service';
import { EmployeeLeaveService } from './services/employeeleave.service';
import { TimetableModule } from '../time-table/timetable.module';
import {
  EmployeeTabComponent,
  EmployeeListComponent,
  LeaveAllocateComponent,
  CourseComponent,
  CourseListComponent,
  TimetableComponent,
  PrivateDocumentComponent,
  DocumentedTrainingComponent,
  LeaveListComponent,
  CourseDetailComponent,
  LeaveEditComponent,
  EmployeeTimetableComponent,
  SicknessListComponent,
  WorkExpEditComponent,
  SicknessEditComponent,
  ApprovalDocumentComponent
} from './components/index';
import { DocumentPreviewComponent } from 'src/app/kuba/shared/document-preview/document-preview.component';
import { TimeTableListResolver } from 'src/app/kuba/employees/services/timetable.resolver.service';
import { EmployeeFormComponent } from './components/employee-form.component';
import { InfoComponent } from './components/info.component';
import { EcplDocumentExplorerModule } from 'src/app/shared/ecpl-document-explorer';
import { EcplDocumentTreeModule } from 'src/app/shared/ecpl-document-tree/ecpl-document-tree.module';
import { EcplPdfViewerModule } from 'src/app/shared/ecpl-pdf-viewer';
import { EcplImageViewerModule } from 'src/app/shared/ecpl-image-viewer';
import { PasswordValidatorModule } from 'src/app/shared/password-validator/password-validator.module';
import { EcplOnlyofficeViewerModule } from 'src/app/shared/ecpl-onlyoffice-viewer';
import { EcplChecklistViewerModule } from 'src/app/shared/ecpl-checklist-viewer';
import { EcplArticleViewerModule } from 'src/app/shared/ecpl-article-viewer/ecpl-article-viewer.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DateRangeWithModule } from '../shared/directives/date-range/date-range-with.module';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { EmployeeDialogMeetingsComponent } from './appraisals/employee-dialog-meetings.component';
import { UtcDatePipe } from './appraisals/shared/utc-date.pipe';
import { AppraisalsListComponent } from './appraisals/components/appraisals-list.component';
import { AppraisalsRequestsComponent } from './appraisals/components/appraisals-requests.component';
import { AppraisalsTasksComponent } from './appraisals/components/appraisals-tasks.component';
import { AppraisalsTemplatesComponent } from './appraisals/components/appraisals-templates.component';
import { AppraisalWorkflowGuideComponent } from './appraisals/components/appraisal-workflow-guide.component';
import { TemplateBuilderComponent } from './appraisals/components/template-builder/template-builder.component';
import { AppraisalTemplateService } from './appraisals/templates/services/appraisal-template.service';
import { AppraisalTemplateSectionService } from './appraisals/templates/services/appraisal-template-section.service';
import { AppraisalTemplateQuestionService } from './appraisals/templates/services/appraisal-template-question.service';
import { AppraisalTemplateAssignmentService } from './appraisals/templates/services/appraisal-template-assignment.service';
import { AppraisalsSettingsComponent } from './appraisals/components/appraisals-settings.component';
import { AppraisalMeetingService } from './appraisals/meetings/services/appraisal-meeting.service';
import { AppraisalSettingsService } from './appraisals/settings/services/appraisal-settings.service';
import { AppraisalMeetingCreateComponent } from './appraisals/meetings/components/appraisal-meeting-create/appraisal-meeting-create.component';
import { AppraisalMeetingDetailComponent } from './appraisals/meetings/components/appraisal-meeting-detail/appraisal-meeting-detail.component';
import { AppraisalTemplateViewComponent } from './appraisals/templates/components/appraisal-template-view/appraisal-template-view.component';
import { AppraisalTaskService } from './appraisals/tasks/services/appraisal-task.service';
import { WorkEnvironmentSurveyComponent } from './work-environment-survey/work-environment-survey.component';
import { SurveyOverviewComponent } from './work-environment-survey/components/survey-overview.component';
import { SurveyAnalysisComponent } from './work-environment-survey/components/survey-analysis.component';
import { SurveyQuestionScoresComponent } from './work-environment-survey/components/survey-question-scores.component';
import { SurveyListComponent } from './work-environment-survey/components/survey-list.component';
import { SurveyScoreGaugeComponent } from './work-environment-survey/components/survey-score-gauge.component';
import { SurveyWizardComponent } from './work-environment-survey/components/survey-wizard/survey-wizard.component';
import { RespondentSurveyComponent } from './work-environment-survey/respondent/respondent-survey.component';
import { WorkEnvironmentSurveyService } from './work-environment-survey/surveys/services/work-environment-survey.service';
import { WorkEnvironmentAnalysisService } from './work-environment-survey/analysis/services/work-environment-analysis.service';
import { RespondentSurveyService } from './work-environment-survey/respondent/services/respondent-survey.service';

@NgModule({
  exports: [
    EmployeesComponent,
    EmployeeTabComponent,
    EmployeeListComponent,
    TimetableComponent,
    CourseComponent,
    CourseListComponent,
    PrivateDocumentComponent,
    DocumentedTrainingComponent,
    EmployeeFormComponent,
    InfoComponent,
    LeaveListComponent,
    RouterModule,
    CourseDetailComponent,
    LeaveEditComponent,
    EmployeeTimetableComponent,
    SicknessListComponent,
    WorkExpEditComponent,
    SicknessEditComponent,
    ApprovalDocumentComponent,
    EmployeeDialogMeetingsComponent,
    AppraisalsListComponent,
    AppraisalsRequestsComponent,
    AppraisalsTasksComponent,
    AppraisalsTemplatesComponent,
    AppraisalWorkflowGuideComponent,
    TemplateBuilderComponent,
    AppraisalsSettingsComponent,
    AppraisalMeetingCreateComponent,
    AppraisalMeetingDetailComponent,
    AppraisalTemplateViewComponent,
    WorkEnvironmentSurveyComponent,
    RespondentSurveyComponent
  ],
  declarations: [
    DocumentPreviewComponent,
    EmployeesComponent,
    EmployeeTabComponent,
    EmployeeListComponent,
    LeaveAllocateComponent,
    CourseComponent,
    CourseListComponent,
    TimetableComponent,
    PrivateDocumentComponent,
    DocumentedTrainingComponent,
    EmployeeFormComponent,
    InfoComponent,
    LeaveListComponent,
    CourseDetailComponent,
    LeaveEditComponent,
    EmployeeTimetableComponent,
    SicknessListComponent,
    WorkExpEditComponent,
    SicknessEditComponent,
    ApprovalDocumentComponent,
    EmployeeDialogMeetingsComponent,
    AppraisalsListComponent,
    AppraisalsRequestsComponent,
    AppraisalsTasksComponent,
    AppraisalsTemplatesComponent,
    AppraisalWorkflowGuideComponent,
    TemplateBuilderComponent,
    AppraisalsSettingsComponent,
    AppraisalMeetingCreateComponent,
    AppraisalMeetingDetailComponent,
    AppraisalTemplateViewComponent,
    UtcDatePipe,
    WorkEnvironmentSurveyComponent,
    SurveyOverviewComponent,
    SurveyAnalysisComponent,
    SurveyQuestionScoresComponent,
    SurveyListComponent,
    SurveyScoreGaugeComponent,
    SurveyWizardComponent,
    RespondentSurveyComponent
  ], imports: [RouterModule,
        EmployeeLicenseUpgradeComponent,
        EmployeeLicenseUsageComponent,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        AppSharedModule,
        EcplDocumentExplorerModule,
        EcplDocumentTreeModule,
        EcplTabNavigationModule,
        PasswordValidatorModule,
        TimetableModule,
        EcplOnlyofficeViewerModule,
        EcplImageViewerModule,
        EcplArticleViewerModule,
        EcplChecklistViewerModule,
        EcplPdfViewerModule,
        PopoverModule,
        MenuModule,
        DateRangeWithModule,
        TranslatePipe, TranslateDirective,
        DragDropModule],
  providers: [
    EmployeeServices,
    EmployeeCourseServices,
    EmployeeSicknessServices,
    EmployeeLeaveService,
    EmployeeFirstOfKinServices,
    EmployeeListResolver,
    EmployeeEditResolver,
    EmployeeWorkExperienceServices,
    EmployeeWorkExperienceResolver,
    EmployeePrivateDocumentServices,
    EmployeePrivateDocResolver,
    ApprovalDocumentResolver,
    EmpLeaveListResolver,
    TimeTableListResolver,
    TimeTableEditResolver,
    CountryCodeResolver,
    EmployeeSicknessListResolver,
    CourseEditResolver,
    CourseListResolver,
    BusinessCourseResolver,
    BusinessContractResolver,
    ApprovalPersonResolver,
    EmployeeTimeTableResolver,
    DepartmentDropDownResolver,
    PositionDropDownResolver,
    EmployeeDropDownResolver,
    EmployeeLeaveResolver,
    EmployeeActiveStatusResolver,
    FirstOfKinListResolver,
    EmpLeaveByLeaveResolver,
    BaseServices,
    SicknessAbsenceCodeResolver,
    ResposibleExecutionResolver,
    EmployeeContactUserResolver,
    FunctionListResolver,
    EmployeeDocResolver,
    EmployeeSicknessByIdResolver,
    PortalEmployeeListResolver,
    PortalCourseListResolver,
    CourseListContractResolver,
    PortalContractListResolver,
    BusinessCreatorResolver,
    // PortalCourseResolver,
    BusinessAbsenceCodesBusinessResolver,
    UserDetailsResolver,
    FeaturesBaseServices,
    BusinessHolidaysResolver,
    EmployeeSubDepartmentResolver,
    EmployeeBusinessDataResolver,
    DocumentedTrainingResolver,
    MultiDocumentedTrainingResolver,
    AppraisalTemplateService,
    AppraisalTemplateSectionService,
    AppraisalTemplateQuestionService,
    AppraisalTemplateAssignmentService,
    AppraisalMeetingService,
    AppraisalSettingsService,
    AppraisalTaskService,
    WorkEnvironmentSurveyService,
    WorkEnvironmentAnalysisService,
    RespondentSurveyService,
        provideHttpClient(withInterceptorsFromDi())
  ]
})
export class EmployeesModule {}
